<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane 
      v-for="item in tabList" 
      :key="item.id" 
      :label="item.label" 
      :name="item.name"
    ></el-tab-pane>

    <!-- 作用域插槽：向外抛出筛选+分页后的列表 -->
    <slot :list="filterList"></slot>
  </el-tabs>
</template>
<script>
  import soft1 from '@/assets/img/soft1.png';
  import soft2 from '@/assets/img/soft2.png';
  import soft3 from '@/assets/img/soft3.png';
  import soft4 from '@/assets/img/soft4.png';
  export default {
    name: 'DigitalTab',
    props:{
        pageInfo:{
          type:Object,
          default:()=>({current:1,pageSize:4})
        },
      },
    data() {
      return {
        activeName: 'all',
        tabList: [
          { id:1, label: '全部类型', name: 'all' },
          { id:2, label: '扫描电镜', name: 'scan' },
          { id:3, label: '原子力显微镜', name: 'force' },
          { id:4, label: '超薄切片机', name: 'slice' },
          { id:5, label: '其他', name: 'other' },
        ],
        productList: [
          {
            id: 1,
            image: soft1,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '96',
            type: '扫描电镜'
          },
          {
            id: 2,
            image: soft2,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '95',
            type: '原子力显微镜'
          },
          {
            id: 3,
            image: soft3,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '92',
            type: '超薄切片机'
          },
          {
            id: 4,
            image: soft1,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '超薄切片机'
          },
          {
            id: 5,
            image: soft4,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '原子力显微镜'
          },{
            id: 6,
            image: soft3,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '原子力显微镜'
          },{
            id: 7,
            image: soft1,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '扫描电镜'
          },{
            id: 8,
            image: soft4,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '超薄切片机'
          },{
            id: 9,
            image: soft2,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '原子力显微镜'
          },{
            id: 10,
            image: soft1,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '扫描电镜'
          },{
            id: 11,
            image: soft2,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '原子力显微镜原子力显微镜'
          },{
            id: 12,
            image: soft3,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '扫描电镜'
          },{
            id: 13,
            image: soft1,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '扫描电镜'
          },{
            id: 14,
            image: soft3,
            title: 'SEM3100扫描电子显微镜',
            tips: '菲泰姆SEM3100...',
            num: '93',
            type: '超薄切片机'
          },
        ],
      };
    },
    computed: {
       filterList() {
         // 1. 按二级 Tab 筛选数据
         let filterArr = this.productList;
         if (this.activeName !== 'all') {
           const targetTab = this.tabList.find(t => t.name === this.activeName);
           filterArr = filterArr.filter(item => item.type === targetTab?.label);
         }

          // 2. 分页截取
         const { current, pageSize} = this.pageInfo;
         const start = (current - 1) * pageSize;
         const end = start + pageSize;
         return filterArr.slice(start, end);
       }
    } ,
    watch: {
      activeName: {
        handler() {
          this.emitTotal();
          this.$emit('reset-page');
        }
      },
      productList: {
        handler() {
          this.emitTotal();

        },
        immediate: true
      },
    },
    methods: {
      // 计算筛选后总条数，发给父组件
      emitTotal() {
        let totalArr = this.productList;
        if (this.activeName !== 'all') {
          const targetTab = this.tabList.find(t => t.name === this.activeName);
          totalArr = totalArr.filter(item => item.type === targetTab?.label);
        }
        this.$emit('page-total', totalArr.length);
      },
      handleClick(tab) {
        this.activeName = tab.name;
      }
    }
  };
  
</script>
<style>
.el-tabs{
  background-color: transparent !important;
  .el-tabs__nav-wrap::after{
      display: none !important;
      border-bottom: none !important;
      height: 0 !important;
  } 
}
</style>
